import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  selectConfirmationFormPayload,
  selectConfirmationFormStatus,
} from '@cashier/cashier-data-access';
import { FormStatuses, ValidationStatuses } from '@cashier/cashier-model';

interface UseSubmitButton {
  isLoading: boolean;
  isDisabled: boolean;
}

export const useSubmitButton = (): UseSubmitButton => {
  const payload = useSelector(selectConfirmationFormPayload);
  const formStatus = useSelector(selectConfirmationFormStatus);

  const isDisabled = useMemo((): boolean => {
    if (formStatus !== FormStatuses.READY) {
      return true;
    }

    const isFormValid = Object.keys(payload || {}).every(
      (fieldName) =>
        payload?.[fieldName].validationStatus === ValidationStatuses.SUCCESS,
    );

    return !isFormValid;
  }, [formStatus, payload]);

  return {
    isDisabled,
    isLoading: formStatus === FormStatuses.SUBMITTED,
  };
};
